import HttpRequestHandler from '@/plugins/http/index';

const http = new HttpRequestHandler({});

export default http;
